export default "__VITE_ASSET__Bsf_aJIJ__"